import React from 'react';
import { ArrowRight } from 'lucide-react';
import PRICING from '../../config/pricing';

const CTASection = ({ onGetFreePhotos }) => {
  return (
    <section className="py-24 bg-stone-900">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-serif text-3xl text-white mb-4">
          Ready to get more views on Flickr, SmugMug, or Unsplash?
        </h2>
        <p className="text-stone-400 mb-8">
          Try {PRICING.getMaxFreePhotos()} photos free. No credit card required.
        </p>
        <button
          onClick={onGetFreePhotos}
          className="bg-white text-stone-900 px-8 py-3.5 rounded font-medium hover:bg-stone-100 transition-colors inline-flex items-center group"
        >
          Start Free Trial
          <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
        </button>
      </div>
    </section>
  );
};

export default CTASection;
